import React, { useEffect,  useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import Avatar from '@material-ui/core/Avatar';
import { Grid, Card, CardContent, Typography } from '@material-ui/core';
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';


const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    maxWidth: 360,
    backgroundColor: theme.palette.background.paper,
  },
}));


const ArtifactListItem = ({ Artifact }) => {
  let comments = Artifact.QcComments !== null && Artifact.QcComments.split(/(\([0-9]{1,2}\/[0-9]{1,2}\/[0-9]{4})/g)
 
    return (
      <ul style={{ listStyleType: "none"} }>
        {comments && comments.map(function(comment, index){
                    return (index%2 === 0 ? <li key={ index } style = {{marginTop: "10px"}}> {comments[index-1]} {comment}</li> : <></>);
                  })}
       
      </ul>
    )
    }

const CommentsDisplay = ({ comment }) => {
  const classes = useStyles();
  const [ comments, setComments ] = useState({ready: false, data: [] });
 
  return (
    <Grid container justify='center'>
      <Grid item xs={12} style={{ padding: 24 }}>
        <Card raised>
          <CardContent>
            <ArtifactListItem Artifact={comment} />
          </CardContent>
        </Card>
      </Grid></Grid>
  )
}

export default CommentsDisplay;